//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {useParams} from 'react-router-dom';

import {useracc, postApi, putApi, deleteApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';
//import Share from '../components/share/share';
//import Gallery from 'react-photo-gallery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
//import axios from 'axios';
//import {Text} from 'react-native';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
//import { ButtonGroup } from 'react-bootstrap';
//import Form from 'react-bootstrap/Form';
//import ProgressBar from 'react-bootstrap/ProgressBar';

import './css/seo.css';

export default class AdminAuthConfirm extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			auth: [],
		};
		
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		//await this.getAuth();

		let url = window.location.href.split('?')[1];
		console.log(window.location.pathname, url);

		const param = new URLSearchParams();
		if( url ) {
			let params = url.split('&');
			for( let i in params ) {
				//console.log(params[i]);
				params[i] = params[i].split('=');
			}

			param.append('auth', window.location.pathname);
			for( let i in params ) {
				param.append( params[i][0], params[i][1] );
			}
			
			console.log(params);
			const x = await putApi('/api/v2/admin/authconfirm', param);
			console.log(x.data);
		}
		

	}

	componentWillUnmount() {
	}

	


	render() {
		
		return (
			<>
				
			</>
		);
	}
}
